import type { PriceInterface } from '@valk-nx/core/lib/interfaces/price.interface';

export function sortByOption<T extends { name: string; price: PriceInterface }>(
	items: T[],
	option: string,
): T[] {
	const sorted = [...items];

	switch (option) {
		case 'name-asc':
			return sorted.sort((a, b) => a.name.localeCompare(b.name));
		case 'name-desc':
			return sorted.sort((a, b) => b.name.localeCompare(a.name));
		case 'price-asc':
			return sorted.sort((a, b) => {
				if (a.price.amount === null && b.price.amount === null)
					return 0;
				if (a.price.amount === null) return 1;
				if (b.price.amount === null) return -1;
				return a.price.amount - b.price.amount;
			});
		case 'price-desc':
			return sorted.sort((a, b) => {
				if (a.price.amount === null && b.price.amount === null)
					return 0;
				if (a.price.amount === null) return 1;
				if (b.price.amount === null) return -1;
				return b.price.amount - a.price.amount;
			});
		default:
			return sorted;
	}
}
